import { colors } from "@/styles/colors"

export const chartColors = {
	enqueued: colors.purple[400],
	onGoing: colors.blue[600],
	finished: colors.green[600]
}
